import React,{ useRef } from 'react';
import axios from 'axios'
import { Table, Input, Button,Collapse,Avatar,Modal,Form,DatePicker,Select,Space,Typography,Divider,InputNumber,message,Spin,Popover,Popconfirm } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon, { PrinterOutlined, MinusOutlined, CloseCircleFilled, CheckCircleOutlined, UserOutlined,DeleteOutlined,EditOutlined } from '@ant-design/icons';
import { SearchOutlined,CameraOutlined,PlusOutlined,LoadingOutlined,DownloadOutlined,MailFilled } from '@ant-design/icons';
import QrReader from 'react-qr-reader'
import uuid from 'react-uuid'
import PhoneInput from 'react-phone-number-input'
import moment from 'moment';
import PrintTemplate from 'react-print';
import ReactToPrint from 'react-to-print';
import * as serverconfig from '../serverconn'
import CurrencyFormat from 'react-currency-format';
import * as reactstrp from 'reactstrap';

import {
  Col,
  Row,
} from 'reactstrap';
import '../tablestyle.css'; // Create this CSS file for custom styles
import ReactExport from "@ibrahimrahmani/react-export-excel";

var CryptoJS = require("crypto-js");

const FormItem=Form.Item;
const { Option } = Select;
const dateFormat = 'DD/MM/YYYY';
const { Title } = Typography;
const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


var sacco= ''
var bizuserid= ''
var token= ''

class ReportToPrint extends React.Component {

    state = {
      companyprofile:{},
    };
  
    componentDidMount(){

      if(localStorage.getItem("sacco")){
         sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
         bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
      
      }else{
         sacco= ''
         bizuserid= ''
      }
      
      if(localStorage.getItem("token")){
         token= localStorage.getItem("token")
      }else{
         token= ''
      }


      axios.defaults.headers={
        "Content-Type":"application/json",
        Authorization:`Token ${token}`
      }

      axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
      .then(res => {  
          this.setState({
            companyprofile: res.data
          })
  
      })

  
    }
  
    render() {
      return (
        <div style={{padding:20}}>
 <Row> 
                <Col xs="2" sm="2" lg="2">
                <img height="100" width="120"  alt="Logo" src={this.state.companyprofile.sacco_logo} />
              
                  </Col>
                  <Col xs="6" sm="6" lg="6">
                  <h3>{this.state.companyprofile.sacco_name}</h3>
                  <h6>Tel: {this.state.companyprofile.RegisteredPhoneNumber1}
                  {
                  this.state.companyprofile.RegisteredPhoneNumber2==""?
                  "":","+this.state.companyprofile.RegisteredPhoneNumber2
                  }
                  {
                  this.state.companyprofile.RegisteredPhoneNumber3==""?
                  "":","+this.state.companyprofile.RegisteredPhoneNumber3
                  }
                  </h6>               
                  <h5>Email: {this.state.companyprofile.company_email}</h5>
                  <h5>Wesite: {this.state.companyprofile.website}</h5>
                  <h5>{this.state.companyprofile.box_number}</h5>
                
                  </Col>
           </Row>

             <h3 style={{display: 'flex',justifyContent:'center', alignItems:'center',fontWeight:'bolder'}}>FINANCIAL STATEMENT REPORT FOR {this.props.selectedmemberobject.AccountNumber} | {this.props.selectedmemberobject.FullName} FROM: {this.props.dateone}  TO: {this.props.datetwo}</h3>
             <reactstrp.Table bordered>
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Desc</th>
                          <th>Sub account</th>

                          <th>Debit</th>
                          <th>Credit</th>
                          
                          <th>Savings balance</th>
                          <th>Savings interest</th>

                          <th>Shares #</th>
                          <th>Shares Amount</th>
                          <th>Loan balance</th>
                          <th>Loan interest</th>
                          <th>Loan fine</th>

                          <th>Fixed deposit</th>
                          <th>Savings loan security</th>
                        
                           <th>Journal number</th>

                        </tr>
                      </thead>
                      <tbody>
                      {this.props.sheetitems.map(
                        (item)=>(
                          <tr>
                          <td>{item.time_stamp}</td>
                          <td>{item.description}</td>
                          <td>{item.subaccount}</td>

                          <td className="align-right">{<CurrencyFormat value={item.debit} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right">{<CurrencyFormat value={item.credit} displayType={'text'} thousandSeparator={true}/>}</td>
                         
                          <td className="align-right">{<CurrencyFormat value={item.savings_balance} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right">{<CurrencyFormat value={item.saving_interestbalance} displayType={'text'} thousandSeparator={true}/>}</td>

                          <td className="align-right">{item.sharesnumber_balance} </td>
                          <td className="align-right">{<CurrencyFormat value={item.sharesamount_balance} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right">{<CurrencyFormat value={item.loan_balance} displayType={'text'} thousandSeparator={true}/>}</td>                         
                          <td className="align-right">{<CurrencyFormat value={item.loaninterest_balance} displayType={'text'} thousandSeparator={true}/>}</td>                         
                          <td className="align-right">{<CurrencyFormat value={item.loanfine_balance} displayType={'text'} thousandSeparator={true}/>}</td>                         
                          <td className="align-right">{<CurrencyFormat value={item.fixed_deposit_balance} displayType={'text'} thousandSeparator={true}/>}</td>                         
                          <td className="align-right">{<CurrencyFormat value={item.savingsloan_security_balance} displayType={'text'} thousandSeparator={true}/>}</td>                         

                          <td className="align-right">{item.journal_no} </td>

                          </tr>
                        ))}

                      <tr>
                          <td className="align-right"><h3>Savings: <CurrencyFormat  value={this.props.selectedmemberobject.savings_balance} displayType={'text'} thousandSeparator={true} /></h3> </td>
                          <td className="align-right"><h3>Savings interest: <CurrencyFormat  value={this.props.selectedmemberobject.saving_interestbalance} displayType={'text'} thousandSeparator={true} /></h3> </td>

                          <td className="align-right"> <h3>Shares amount  : <CurrencyFormat  value={this.props.selectedmemberobject.sharesamount_balance} displayType={'text'} thousandSeparator={true} /></h3></td>
                          <td className="align-right"><h3>Shares no : {this.props.selectedmemberobject.sharesnumber_balance}</h3></td>

                          <td className="align-right"><h3>Loan : <CurrencyFormat  value={this.props.selectedmemberobject.loan_balance} displayType={'text'} thousandSeparator={true} /></h3></td>
                          <td className="align-right"><h3>Loan interest : <CurrencyFormat  value={this.props.selectedmemberobject.loaninterest_balance} displayType={'text'} thousandSeparator={true} /></h3></td>
                          <td className="align-right"><h3>Loan fine : <CurrencyFormat  value={this.props.selectedmemberobject.loanfine_balance} displayType={'text'} thousandSeparator={true} /></h3></td>
                          <td className="align-right"><h3>Fixed deposit : <CurrencyFormat  value={this.props.selectedmemberobject.fixed_deposit_balance} displayType={'text'} thousandSeparator={true} /></h3></td>

                          <td className="align-right"><h3>Reserve (Savings loan security) : <CurrencyFormat  value={this.props.selectedmemberobject.savingsloan_security_balance} displayType={'text'} thousandSeparator={true} /></h3></td>

                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>

                        </tr>

                    </tbody>
                </reactstrp.Table>

                <br></br>
                <h3>Generated by: {CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)}</h3>
                <h3>Powered by: www.pitech.co.ug</h3>   
        </div>
      );
    }
  }


class FinancialStatementReportPerMember extends React.Component {

  state = {
    members:[],    
    sheetitems:[],
    dateone:'',
    datetwo:'',
    selectedmemberobject:{},
    selectedmemberid:'',
    totaldebit:0,
    totalcredit:0,
    datarequested:false,
    companyprofile:{},
    userprofile:{},

    deletelist:[],

    editmodalvisiblae:false,
    selectedtranobj:{},
    credit:0,
    debit:0,
    balance:0,
    transdesc:'',

    sharesamount_balance:0,
    sharesnumber_balance:0,
    loan_balance:0,
    savingsloan_security_balance:0,
    shares_security_balance:0,

    reversalmodal_visible:false,
    selected_journal:{},
    tobereversed_transactions:[],
    loan_txn_report:[],
    general_ledger_entriesreport:[],
    txndetailsmodal_visible:false,
    userrights:{},


   };

   componentDidMount(){
      if(localStorage.getItem("sacco")){
        sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
        bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
    
    }else{
        sacco= ''
        bizuserid= ''
    }
    
    if(localStorage.getItem("token")){
        token= localStorage.getItem("token")
    }else{
        token= ''
    }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
    .then(res => {  
        this.setState({
          companyprofile: res.data
        })

    })

    axios.get(serverconfig.backendserverurl+`/api/members_dataview/?sacco=${sacco}`)
    .then(res => {
        this.setState({
          members:res.data
        })
      })

      axios.get(`${serverconfig.backendserverurl}/api/accounts/${bizuserid}`)
      .then(res => {  
          this.setState({
            userprofile: res.data
          })
      })

      axios.get(serverconfig.backendserverurl+`/api/accountrights/?user=${bizuserid}`)
      .then(res => {
          this.setState({
            userrights:res.data[0]
          })
      })

      //mmeber change
     this.handlememberChange(this.props.member_id)

  }
 
   handledatechange= (date, dateString) =>{
     this.setState({ dateone: dateString[0]});
     this.setState({ datetwo: dateString[1]});
   } 

   handlememberChange= (e) =>{
    this.setState({ selectedmemberid: e});

    axios.get(`${serverconfig.backendserverurl}/api/members_dataview/${e}`)
    .then(res => {  
        this.setState({selectedmemberobject: res.data})
    })

   } 

 
   //search sales method
   searchSales=()=>{

    let form_data = new FormData();
    form_data.append('dateone', this.state.dateone);
    form_data.append('datetwo', this.state.datetwo);
    form_data.append('memberid', this.state.selectedmemberid);
    form_data.append('sacco', sacco);
    
    console.log(this.state.entrant)
      
    if(this.state.selectedmemberid===''||this.state.dateone===''||this.state.datetwo===''){
      alert("Please select entrant or dates missing")
    }else{
        this.setState({datarequested:true})

        //Now submit sale data to database
        axios.post(serverconfig.backendserverurl+'/customqueries/getmemberfinancialstatement', form_data,{
        headers: {
          'content-type': 'multipart/form-data'
        }
        })
        .then(res =>{
          this.setState({datarequested:false})

            this.setState({sheetitems:JSON.parse(res.data.report)})
            this.setState({totaldebit:res.data.totalDebit})
            this.setState({totalcredit:res.data.totalCredit})
        } 
        )
        .catch(error => console.log(error))   
    }

    }

   ////////////////////////////////////
  // USER SEARCH SELECT METHODS
  onBlur=()=> {
    console.log('blur');
  }
  
   onFocus=()=>{
    console.log('focus');
  }
  
  onSearch=(val)=> {
    console.log('search:', val);
  }
 

   ////////////////////////////////////////////
   // RENDERING METHOD HERE
   render() {
       
       if(this.state.datarequested===true){
        return(
          <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
          <Spin indicator={antIcon} />
          </div>
        )
      }else{

        return(
          <div>
            <div style={{display: "none"}}>
               &nbsp;&nbsp;
              <ReportToPrint
              totaldebit={this.state.totaldebit} 
              totalcredit={this.state.totalcredit} 
              dateone={this.state.dateone}
              datetwo={this.state.datetwo}
              sheetitems={this.state.sheetitems}
              selectedmemberobject={this.state.selectedmemberobject}
              ref={el => (this.componentRef = el)} /> 
            </div>
  
            <Collapse defaultActiveKey={['1']} onChange={this.callback}>
              <Panel header="MEMBER FINANCIAL STATEMENT REPORT" key="1">

              <div style={{display:'flex',justifyContent:'flex-start'}}>
                            
              <ReactToPrint
                trigger={() => 
                <Button type="primary"  shape="round" icon={<PrinterOutlined />} size={this.state.size}>
                Print
                </Button>
                }
                content={() => this.componentRef}
                />
                &nbsp;
                &nbsp;
                &nbsp;
                &nbsp;
                &nbsp;

              <Button type='primary'
                icon={<MailFilled/>}
                
                onClick={
                ()=>{
                  let form_data = new FormData();
                  form_data.append('dateone', this.state.dateone);
                  form_data.append('datetwo', this.state.datetwo);
                  form_data.append('memberid', this.state.selectedmemberid);
                  form_data.append('sacco', sacco);
                  
                  console.log(this.state.entrant)
                    
                  if(this.state.selectedmemberid===''||this.state.dateone===''||this.state.datetwo===''){
                    alert("Please select entrant or dates missing")
                  }else{
                      this.setState({datarequested:true})
              
                      //Now submit sale data to database
                      axios.post(serverconfig.backendserverurl+'/customqueries/emailmemberfinancialstatement', form_data,{
                      headers: {
                        'content-type': 'multipart/form-data'
                      }
                      })
                      .then(res =>{
                        this.setState({datarequested:false})
                        message.info(res.data.message)
                      } 
                      )
                      .catch(error => console.log(error))   
                  }
                }
                }
                
                >
                Send via eMail
              </Button>

              &nbsp;&nbsp;

<ExcelFile filename={"Pisacco - Financial statement report for "+this.state.selectedmemberobject.FullName+" from "+this.state.dateone+" to "+this.state.datetwo}  element={<Button type='primary' icon={<DownloadOutlined/>}>Download (Excel)</Button>}>
  <ExcelSheet data={this.state.sheetitems} name={"Financial statement report"}>
      <ExcelColumn label="Date" value="time_stamp"/>
      <ExcelColumn label="Description" value="description"/>

      <ExcelColumn label="Sub account" value="subaccount"/>
      <ExcelColumn label="Debit" value="debit"/>
      <ExcelColumn label="Credit" value="credit"/>
      <ExcelColumn label="Savings balance" value="savings_balance"/>
      <ExcelColumn label="Savings interest" value="saving_interestbalance"/>

      <ExcelColumn label="Shares No" value="sharesnumber_balance"/>
      <ExcelColumn label="Shares Amount" value="sharesamount_balance"/>
      <ExcelColumn label="Loan balance" value="loan_balance"/>
      <ExcelColumn label="Loan interest" value="loaninterest_balance"/>
      <ExcelColumn label="Loan fine" value="loanfine_balance"/>
      <ExcelColumn label="Fixed deposit" value="fixed_deposit_balance"/>
      <ExcelColumn label="Savings loan security" value="savingsloan_security_balance"/>
      <ExcelColumn label="Journal number" value="journal_no"/>

  </ExcelSheet>
</ExcelFile>




              </div>
              <br></br>
              <br></br>

              <Form  layout="inline" >
              <FormItem label="Members">
                     <Select 
                     placeholder="Account"
                     style={{ width: 300 }} 
                     value={this.state.selectedmemberid} 
                     onChange={this.handlememberChange}
                      
                     showSearch
                     optionFilterProp="children"
                     onFocus={this.onFocus}
                     onBlur={this.onBlur}
                     onSearch={this.onSearch}                     
                      >
                       {this.state.members.map(
                         (member)=>{

                          if(this.props.member_id===member.id){
                            return (
                              <Option value={member.id}>{member.AccountNumber} | {member.FullName}</Option>
                            );
                          }

                         })}
                     </Select>
                 </FormItem>
 
 
                  <FormItem label="Date Range">
                      <RangePicker defaultValue={moment()} onChange={this.handledatechange} format={dateFormat} />
                  </FormItem>
  
                  <FormItem>
                  <Button onClick={this.searchSales} type="primary" htmlType="button">Search</Button>
                  </FormItem> 
  
             </Form>
  
             <br></br>
             <div style={{overflowX : 'auto'}}>
             <reactstrp.Table bordered>
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Desc</th>
                          <th>Sub account</th>

                          <th>Debit</th>
                          <th>Credit</th>
                          
                          <th>Savings balance</th>
                          <th>Savings interest</th>

                          <th>Shares #</th>
                          <th>Shares Amount</th>
                          <th>Loan balance</th>
                          <th>Loan interest</th>
                          <th>Loan fine</th>

                          <th>Fixed deposit</th>
                          <th>Savings loan security</th>
                        
                          <th>Journal number</th>

                          {
                          this.state.companyprofile.allow_transaction_reversal===true && this.state.userrights.can_make_transaction_reversals===true?
                            <th>Reverse</th>
                          :
                          null
                        }

                        </tr>
                      </thead>
                      <tbody>
                      {this.state.sheetitems.map(
                        (item)=>(
                          <tr>
                          <td>{item.time_stamp}</td>
                          <td>{item.description}</td>
                          <td>{item.subaccount}</td>

                          <td className="align-right">{<CurrencyFormat value={item.debit} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right">{<CurrencyFormat value={item.credit} displayType={'text'} thousandSeparator={true}/>}</td>
                         
                          <td className="align-right">{<CurrencyFormat value={item.savings_balance} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right">{<CurrencyFormat value={item.saving_interestbalance} displayType={'text'} thousandSeparator={true}/>}</td>

                          <td className="align-right">{item.sharesnumber_balance} </td>
                          <td className="align-right">{<CurrencyFormat value={item.sharesamount_balance} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right">{<CurrencyFormat value={item.loan_balance} displayType={'text'} thousandSeparator={true}/>}</td>                         
                          <td className="align-right">{<CurrencyFormat value={item.loaninterest_balance} displayType={'text'} thousandSeparator={true}/>}</td>                         
                          <td className="align-right">{<CurrencyFormat value={item.loanfine_balance} displayType={'text'} thousandSeparator={true}/>}</td>                         
                          <td className="align-right">{<CurrencyFormat value={item.fixed_deposit_balance} displayType={'text'} thousandSeparator={true}/>}</td>                         
                          <td className="align-right">{<CurrencyFormat value={item.savingsloan_security_balance} displayType={'text'} thousandSeparator={true}/>}</td>                         

                          <td className="align-right">{item.journal_no} </td>


                        {
                          this.state.companyprofile.allow_transaction_reversal && this.state.userrights.can_make_transaction_reversals?
                          <th><Button type='primary' onClick={()=>{


                            //make qery now
                            let form_data = new FormData();
                            form_data.append('date',item.date);
                            form_data.append('selectedmemberid', this.state.selectedmemberid);
                            form_data.append('journalno', item.journal_no);
                            form_data.append('sacco', sacco);
                      
                            axios.post(serverconfig.backendserverurl+'/customqueries/queryreversal_transactions', form_data, {
                              headers: {
                                'content-type': 'multipart/form-data'
                              }
                              })
                            .then(res => {
                              this.setState({tobereversed_transactions:JSON.parse(res.data.txn_report)})
                              this.setState({loan_txn_report:JSON.parse(res.data.loan_txn_report)})
                              this.setState({general_ledger_entriesreport:JSON.parse(res.data.general_ledger_entriesreport)})

                            })
                            .catch(error => console.log(error))


                            this.setState({reversalmodal_visible:true})
                            this.setState({selected_journal:item})


                          }}>Reverse</Button></th>
                          :
                          null
                        }

                          </tr>
                        ))}

                      <tr>
                          <td className="align-right"><h3>Savings: <CurrencyFormat  value={this.state.selectedmemberobject.savings_balance} displayType={'text'} thousandSeparator={true} /></h3> </td>
                          <td className="align-right"><h3>Savings interest: <CurrencyFormat  value={this.state.selectedmemberobject.saving_interestbalance} displayType={'text'} thousandSeparator={true} /></h3> </td>

                          <td className="align-right"> <h3>Shares amount  : <CurrencyFormat  value={this.state.selectedmemberobject.sharesamount_balance} displayType={'text'} thousandSeparator={true} /></h3></td>
                          <td className="align-right"><h3>Shares no : {this.state.selectedmemberobject.sharesnumber_balance}</h3></td>

                          <td className="align-right"><h3>Loan : <CurrencyFormat  value={this.state.selectedmemberobject.loan_balance} displayType={'text'} thousandSeparator={true} /></h3></td>
                          <td className="align-right"><h3>Loan interest : <CurrencyFormat  value={this.state.selectedmemberobject.loaninterest_balance} displayType={'text'} thousandSeparator={true} /></h3></td>
                          <td className="align-right"><h3>Loan fine : <CurrencyFormat  value={this.state.selectedmemberobject.loanfine_balance} displayType={'text'} thousandSeparator={true} /></h3></td>
                          <td className="align-right"><h3>Fixed deposit : <CurrencyFormat  value={this.state.selectedmemberobject.fixed_deposit_balance} displayType={'text'} thousandSeparator={true} /></h3></td>

                          <td className="align-right"><h3>Reserve (Savings loan security) : <CurrencyFormat  value={this.state.selectedmemberobject.savingsloan_security_balance} displayType={'text'} thousandSeparator={true} /></h3></td>

                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>

                        </tr>

                    </tbody>
                </reactstrp.Table>

              </div>
             

              </Panel>
              </Collapse>



            <Modal              
              visible={this.state.reversalmodal_visible}
              title={"Transaction reversal details (All transactions with same journal number)"}
              onCancel={()=>{this.setState({reversalmodal_visible:false})}}
              //style={{width:1000}}
              width={1500}
              footer={[
                <Button type='default' key="back" onClick={()=>{this.setState({reversalmodal_visible:false})}}>
                Cancel
               </Button>,
                <Button  type='primary' key="ok" onClick={()=>{

                  //make qery now
                  let form_data = new FormData();
                  form_data.append('date',this.state.selected_journal.date);
                  form_data.append('selectedmemberid', this.state.selectedmemberid);
                  form_data.append('journalno', this.state.selected_journal.journal_no);
                  form_data.append('sacco', sacco);
            
                  axios.post(serverconfig.backendserverurl+'/customqueries/confirmtransaction_revsersal', form_data, {
                    headers: {
                      'content-type': 'multipart/form-data'
                    }
                    })
                  .then(res => {
                    message.info(res.data.message)

                    //get financial statement again
                    this.searchSales()

                    axios.get(`${serverconfig.backendserverurl}/api/members/${this.state.selectedmemberid}`)
                    .then(res => {  
                        this.setState({selectedmemberobject: res.data})
                    })
                    //updated balance

                  })
                  .catch(error => console.log(error))

                  this.setState({reversalmodal_visible:false})
                  
                  }}>
                  Confirm reversal
                </Button>
                ]}
                >
                  <div>
                    <h3>Member statement transactions</h3>
                  <reactstrp.Table bordered>
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Desc</th>
                          <th>Sub account</th>
                          <th>Debit</th>
                          <th>Credit</th>
                          <th>Journal number</th>
                        </tr>
                      </thead>
                      <tbody>
                      {this.state.tobereversed_transactions.map(
                        (item)=>(
                          <tr>
                          <td>{item.time_stamp}</td>
                          <td>{item.description}</td>
                          <td>{item.subaccount}</td>
                          <td className="align-right">{<CurrencyFormat value={item.debit} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right">{<CurrencyFormat value={item.credit} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right">{item.journal_no} </td>
                          </tr>
                          ))}

                    </tbody>
                </reactstrp.Table>
                <Divider />
                <h3>Loan track transactions</h3>
                <reactstrp.Table bordered>
                              <thead>
                                <tr>
                                <th>Date</th>
                                <th>User</th>
                                <th>Desc</th>
                                <th>Principle Paid</th>
                                <th>Interest Paid</th>
                                <th>Fine Paid</th>
                                <th>Total Paid</th>
                                <th>Principle Balance</th>
                                <th>Interest Balance</th>
                                <th>Total Balance</th>

                                </tr>
                              </thead>
                              <tbody>
                              {this.state.loan_txn_report.map(
                                (item)=>(
                                  <tr>
                                  <td>{item.date}</td>
                                  <td>{item.user==null?item.payment_by:item.user}</td>
                                  <td>{item.description}</td>
                                  <td className="align-right">{<CurrencyFormat value={item.principle_paid} displayType={'text'} thousandSeparator={true}/>}</td>
                                  <td className="align-right">{<CurrencyFormat value={item.interest_paid} displayType={'text'} thousandSeparator={true}/>}</td>
                                  <td className="align-right">{<CurrencyFormat value={item.fine_paid} displayType={'text'} thousandSeparator={true}/>}</td>
                                  <td className="align-right">{<CurrencyFormat value={item.total_paid} displayType={'text'} thousandSeparator={true}/>}</td>
                                  <td className="align-right">{<CurrencyFormat value={item.principle_balance} displayType={'text'} thousandSeparator={true}/>}</td>
                                  <td className="align-right">{<CurrencyFormat value={item.interest_balance} displayType={'text'} thousandSeparator={true}/>}</td>
                                  <td className="align-right">{<CurrencyFormat value={item.loan_balance} displayType={'text'} thousandSeparator={true}/>}</td>

                                  </tr>
                                ))}
                           
                            </tbody>
                        </reactstrp.Table>
                        <Divider />
                        <h3>General ledger transactions</h3>
                        <reactstrp.Table bordered>
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Account</th>
                          <th>Desc</th>
                          <th>User</th>
                          <th>Debit</th>
                          <th>Credit</th>
                          <th>Journal No</th>

                        </tr>
                      </thead>
                      <tbody>
                      {this.state.general_ledger_entriesreport.map(
                        (item)=>(
                          <tr>
                          <td>{item.date}</td>
                          <td>{item.account}</td>
                          <td>{item.description}</td>
                          <td>{item.user}</td>
                          <td className="align-right">{<CurrencyFormat value={item.Debit} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right">{<CurrencyFormat value={item.Credit} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td className="align-right">{item.journal_no}</td>

                          </tr>
                        ))}
                       
                    </tbody>
                 </reactstrp.Table> 

                  </div>
               </Modal> 

          </div>
      )        

      }
   
   }
}

export default FinancialStatementReportPerMember; 
